import styled from 'styled-components';

export const TruncatedCell = styled.span`
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  display: block;
`;

export const CapitalizedCell = styled.span`
  text-transform: capitalize;
`;

export const ScheduleTableWrapper = styled.div`
  height: 100%;

  .schedule-disabled .BaseTable__row-cell-text {
    opacity: 0.45;
    color: rgb(0 0 0 / 25%);
  }

  .BaseTable__header-cell,
  .BaseTable__row-cell {
    border-right: 1px solid #e8e8e8;

    &:last-child {
      border-right: none;
    }
  }
`;
